export enum ETabOption {
  SUBSCRIPTION = 'SUBSCRIPTION',
  PLANS = 'PLANS',
}
